<template>
  <header ref="header" :class="{ 'header--with-bg' : pageOnTop, 'colored' : hasColoredBackground }">
    <desktop-navigation :header="this"></desktop-navigation>
    <mobile-navigation :header="this"></mobile-navigation>
  </header>
</template>

<script>
  import { throttle } from 'lodash'

  export default {
    name: 'TeamsiteHeader',

    props: {
      /**
       * Text, URL, and Hint above the Contact Button in the Mobile Navigation
       */
      contact: {
        required: true,
        type: Object
      },
      /**
       * Title and URL for the login link of the portal.
       */
      login: {
        required: true,
        type: Object
      },
      /**
       * Menu items to be displayed on the nav bar.
       */
      navItems: {
        required: true,
        type: Array
      },
      /**
       * Root path of the app.
       */
      rootPath: {
        required: true,
        type: String
      },

      /**
       * Color used for buttons inside the header (e.g. contact)
       */
      buttonColor: {
        required: false,
        type: String,
        default: 'red'
      },

      backgroundColor: {
        required: false,
        type: String,
        default: null
      },

      pageLayout: {
        required: false,
        type: String,
        default: null
      }
    },

    data () {
      return {
        pageOnTop: false
      }
    },

    beforeDestroy () {
      window.removeEventListener('scroll', this.handleScroll)
    },

    mounted () {
      window.addEventListener('scroll', _.throttle(this.handleScroll, 100))
      setTimeout(this.handleScroll, 200)
    },

    computed: {
      hasColoredBackground () {
        return this.pageLayout != 'hero'
      }
    },

    methods: {
      handleScroll () {
        let offset = this.subpageLayout ? 5 : 50
        this.pageOnTop = window.pageYOffset >= offset
      }
    }
  }
</script>

<style lang="scss">
  header {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 9999;
    line-height: rem-calc(50);
    padding-top: rem-calc(40);
    padding-bottom: rem-calc(20);
    background-color: transparent;
    transition: background-color 350ms, padding 150ms;

    @include breakpoint(medium down) {
      padding-top: rem-calc(20);
      padding-bottom: 0;
    }

    &.header--with-bg {
      background-color: white;
      padding-top: rem-calc(12);
      padding-bottom: 0;
      height: 100px;

      @include breakpoint(large up) {
        .contact-link {
          display: block;
        }
      }

      @include breakpoint(medium down) {
        padding-bottom: rem-calc(5);
        height: 85px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TeamsiteHeader.vue